/**
 * TimelineSunIntensity Component
 *
 * Renders sun intensity gradient row using cosine wave for seasonal variation.
 * Visual indicator of daylight changes throughout the year.
 */

import React from 'react'

/**
 * TimelineSunIntensity - Sun intensity gradient row
 *
 * @param {Object} props
 * @param {Array} props.weeks - Array of week objects with sunColor
 * @param {number} props.weekWidth - Pixels per week
 */
export const TimelineSunIntensity = ({ weeks, weekWidth }) => {
  return (
    <>
      {weeks.map((w, i) => (
        <rect
          key={`sun-${i}`}
          x={i * weekWidth}
          y={30}
          width={weekWidth}
          height={20}
          fill={w.sunColor}
        />
      ))}
    </>
  )
}
